(() => {
const $caa775a85f16e8d6$export$e27bccc8afa33d09 = (dates, reverse = false)=>{
    dates.sort((a, b)=>b.dates.end_date - a.dates.end_date);
    reverse && dates.reverse();
};
const $caa775a85f16e8d6$export$82939fba51e2faaf = (events, currentTimestamp)=>{
    events.forEach((event)=>{
        // if the there are multiple dates in event.date array check if one of the dates is in the future if yes set this start and end timestamp as new date array
        if (event.repeating) {
            for (const element of event.repeating)// if there is a date in the future set this as new date array
            if (element.end_date > currentTimestamp) {
                // set the new date array
                event.dates = {
                    start_date: element.start_date,
                    end_date: element.end_date
                };
                // Set the links for the event
                event.links = element.links;
                break;
            } else {
                // Set the last date as the date array
                event.dates = element;
                // Set the links for the event
                event.links = element.links;
            }
        }
    });
    return events;
};
const $caa775a85f16e8d6$export$d85fd0095082f726 = (events)=>{
    return events.filter((event)=>{
        return event.dates.start_date !== null && event.dates.end_date !== null;
    });
};
const $caa775a85f16e8d6$export$abcd98354d9fb0f7 = (timeFilter, events)=>{
    const currentTimestamp = Math.floor(Date.now() / 1000);
    switch(timeFilter){
        case 'upcoming_events':
            // Remove always available events from the list.
            events = $caa775a85f16e8d6$export$d85fd0095082f726(events);
            // Build the repeating events.
            events = $caa775a85f16e8d6$export$82939fba51e2faaf(events, currentTimestamp);
            // Get all upcoming events with the same category filtered by the API.
            events = events.filter((event)=>event.dates.end_date > currentTimestamp);
            // Sort the most recent events to display first.
            $caa775a85f16e8d6$export$e27bccc8afa33d09(events, true);
            return events;
        case 'past_events':
            // Remove always available events from the list.
            events = $caa775a85f16e8d6$export$d85fd0095082f726(events);
            // Build the repeating events.
            events = $caa775a85f16e8d6$export$82939fba51e2faaf(events, currentTimestamp);
            // Provides events that took place in the past.
            events = events.filter((event)=>event.dates.end_date < currentTimestamp);
            // Sorts the past events in descending order, according to when they were held.
            $caa775a85f16e8d6$export$e27bccc8afa33d09(events);
            // Reduce the amount of past events to a maximum of 20.
            events = events.slice(0, 20);
            return events;
        case 'always_available_events':
            // Reduce the amount of past events to a maximum of 20.
            events = events.slice(0, 20);
            // Return all events.
            return events;
    }
};


const $4d206bedaaca27bd$export$16c08b91f883959a = {
    selectors: {
        events: '.events',
        truncate: '.event__description--truncate'
    },
    classes: {
        ctr: 'events__ctr',
        container: 'container',
        badges: 'badges',
        badge: 'badge',
        meta: 'event__meta',
        location: 'event__location',
        icon: 'event__icon',
        date: 'event__date',
        description: 'event__description',
        descriptionInner: 'event__description-inner',
        truncate: 'event__description--truncate',
        closed: 'event__description--closed',
        clamp: 'event__description--clamp',
        noEvents: 'event__no-events',
        infobox: 'infobox infobox--info-primary'
    }
};



const $84bd0f83cdc12d01$export$e7b6f2bce646ceb2 = (ctr)=>{
    // Add an event listener to the truncated elements.
    const truncatedElms = ctr.querySelectorAll((0, $4d206bedaaca27bd$export$16c08b91f883959a).selectors.truncate);
    truncatedElms.forEach((elm)=>{
        // Get the height of the element when the text is not yet truncated.
        const expandedInnerRect = elm.getBoundingClientRect();
        elm.style.setProperty('--truncate-height-expanded', `${expandedInnerRect.height}px`);
        // Add a class to the element to indicate that the text is truncated.
        elm.classList.add((0, $4d206bedaaca27bd$export$16c08b91f883959a).classes.closed, (0, $4d206bedaaca27bd$export$16c08b91f883959a).classes.clamp);
        elm.addEventListener('click', ()=>{
            elm.classList.toggle((0, $4d206bedaaca27bd$export$16c08b91f883959a).classes.closed);
            if (elm.classList.contains((0, $4d206bedaaca27bd$export$16c08b91f883959a).classes.closed)) setTimeout(()=>elm.classList.add((0, $4d206bedaaca27bd$export$16c08b91f883959a).classes.clamp), 300);
            else elm.classList.remove((0, $4d206bedaaca27bd$export$16c08b91f883959a).classes.clamp);
        });
    });
};
const $84bd0f83cdc12d01$var$getTheIso8601DateFormat = (date)=>{
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const timeString = `${year}-${month}-${day}T${hours}:${minutes}`;
    return timeString;
};
const $84bd0f83cdc12d01$var$getSchemaAttribute = (itemprop, date = new Date(), inline = true)=>{
    const atributes = `itemprop="${itemprop}" content="${$84bd0f83cdc12d01$var$getTheIso8601DateFormat(new Date(date))}"`;
    if (inline) return atributes;
    else return `<span ${atributes}></span>`;
};
const $84bd0f83cdc12d01$var$getDates = (startDate, endDate)=>{
    const browserLanguage = document.querySelector('html')?.lang;
    // Format the dates and times
    const dateFormatOptions = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        timeZoneName: 'short'
    };
    const timeFormatOptions = {
        hour: 'numeric',
        minute: 'numeric'
    };
    const dateFormat = new Intl.DateTimeFormat(browserLanguage, dateFormatOptions);
    const timeFormat = new Intl.DateTimeFormat(browserLanguage, timeFormatOptions);
    if (!startDate) return `<div ${$84bd0f83cdc12d01$var$getSchemaAttribute('startDate')}"></div>`;
    // Convert PHP timestamps (seconds) to JavaScript timestamps (milliseconds)
    startDate = startDate * 1000;
    endDate = endDate ? endDate * 1000 : null;
    const startDateTime = dateFormat.format(startDate) + ', ' + timeFormat.format(startDate);
    let formattedString = '';
    const schemaStartDate = $84bd0f83cdc12d01$var$getSchemaAttribute('startDate', startDate);
    let schemaEndDate = '';
    if (!endDate) formattedString = startDateTime;
    else if (dateFormat.format(startDate) === dateFormat.format(endDate)) {
        const endTime = timeFormat.format(endDate);
        formattedString = `${startDateTime}&ndash;${endTime}`;
        schemaEndDate = $84bd0f83cdc12d01$var$getSchemaAttribute('endDate', endDate, false);
    } else {
        const endDateTime = dateFormat.format(endDate) + ', ' + timeFormat.format(endDate);
        formattedString = `${startDateTime}&ndash;${endDateTime}`;
        schemaEndDate = $84bd0f83cdc12d01$var$getSchemaAttribute('endDate', endDate, false);
    }
    return `<div class="${(0, $4d206bedaaca27bd$export$16c08b91f883959a).classes.date}"><span class="${(0, $4d206bedaaca27bd$export$16c08b91f883959a).classes.icon}">event</span><span ${schemaStartDate}>${formattedString}</span>${schemaEndDate}</div>`;
};
const $84bd0f83cdc12d01$export$88411125f012957a = (city)=>{
    return `
	<div itemprop="address" itemscope itemtype="https://schema.org/PostalAddress">
		, <span itemprop="addressLocality">${city}</span>
	</div>
	`;
};
const $84bd0f83cdc12d01$export$7f6e1f46695e51c4 = (date)=>{
    let badges = '';
    date.categories.forEach((category)=>{
        badges += `<span class="${(0, $4d206bedaaca27bd$export$16c08b91f883959a).classes.badge}">${category}</span>`;
    });
    return `<div class="${(0, $4d206bedaaca27bd$export$16c08b91f883959a).classes.badges}">${badges}</div>`;
};
const $84bd0f83cdc12d01$var$getLocation = (location, online)=>{
    const name = `
		<span class="${(0, $4d206bedaaca27bd$export$16c08b91f883959a).classes.icon}">location_on</span>
		<span itemprop="name">${location.online ? online : location.name}</span>
		${!location.online ? $84bd0f83cdc12d01$export$88411125f012957a(location.city) : ''}
	`;
    return `
	<div itemprop="location" itemscope itemtype="https://schema.org/Place" class="${(0, $4d206bedaaca27bd$export$16c08b91f883959a).classes.location}">
		${location.maps_url !== '' ? `<a href="${location.maps_url}" target="_blank" rel="noopener">${name}</a>` : name}
	</div>
	`;
};
const $84bd0f83cdc12d01$var$createAnchorTag = (link)=>{
    return `<a href="${link.url}" target="_blank" class="btn btn-secondary ${link.indicator}" itemprop="url">${link.label}</a>`;
};
const $84bd0f83cdc12d01$var$getTheLink = (links, dates)=>{
    if (dates.end_date === null || dates.start_date === null) return links.always.url !== '' ? $84bd0f83cdc12d01$var$createAnchorTag(links.always) : '';
    const currentTimestamp = Math.floor(Date.now() / 1000);
    if (dates.end_date > currentTimestamp) // Check if the event is still in the future, then display a link that is relevant to the future of the event.
    return links.before.url !== '' ? $84bd0f83cdc12d01$var$createAnchorTag(links.before) : '';
    else // Check if the event is in the past, then display a link that is relevant to the past of the event.
    return links.after.url !== '' ? $84bd0f83cdc12d01$var$createAnchorTag(links.after) : '';
};
const $84bd0f83cdc12d01$export$3d68e9f97805ee52 = (date, labels)=>{
    const { title: title, thumb: thumb, links: links, dates: dates, excerpt: excerpt, location: location } = date;
    return `
	<div class="row event" itemscope itemtype="https://schema.org/Event">
		<div class="col-xl-5">${thumb}</div>
		<div class="col-xl-7">
			${$84bd0f83cdc12d01$export$7f6e1f46695e51c4(date)}
			<h5 itemprop="name">${title}</h5>
			<div class="${(0, $4d206bedaaca27bd$export$16c08b91f883959a).classes.meta}">
				${$84bd0f83cdc12d01$var$getDates(dates.start_date, dates.end_date, dates.time_zone)}
				${location && dates.end_date !== null ? $84bd0f83cdc12d01$var$getLocation(location, labels.online) : ''}
			</div>
			<div itemprop="description" class="${(0, $4d206bedaaca27bd$export$16c08b91f883959a).classes.description} ${excerpt.length > 70 && (0, $4d206bedaaca27bd$export$16c08b91f883959a).classes.truncate}">
				<div class="${(0, $4d206bedaaca27bd$export$16c08b91f883959a).classes.descriptionInner}">${excerpt.text}</div>
			</div>
			${$84bd0f83cdc12d01$var$getTheLink(links, dates)}
		</div>
	</div>`;
};
const $84bd0f83cdc12d01$export$ff0eb5149c4c561a = (node, labels, events)=>{
    // Create wrapper for each event section.
    const wrapper = document.createElement('div');
    wrapper.setAttribute('class', (0, $4d206bedaaca27bd$export$16c08b91f883959a).classes.ctr);
    events.forEach((date)=>{
        wrapper.innerHTML += $84bd0f83cdc12d01$export$3d68e9f97805ee52(date, labels);
    });
    node.append(wrapper);
};
const $84bd0f83cdc12d01$export$8f410212441577b3 = (ctr, message)=>{
    const noEvents = document.createElement('div');
    noEvents.setAttribute('class', (0, $4d206bedaaca27bd$export$16c08b91f883959a).classes.noEvents);
    const paragraph = document.createElement('p');
    paragraph.setAttribute('class', (0, $4d206bedaaca27bd$export$16c08b91f883959a).classes.infobox);
    paragraph.innerText = message;
    noEvents.append(paragraph);
    ctr.append(noEvents);
};


const $933adbd7235e0034$var$observer = new IntersectionObserver((entries)=>{
    entries.forEach((entry)=>{
        const ctr = entry.target;
        if (entry.isIntersecting) fetch(ctr.dataset.restEndpoint).then((response)=>response.json()).then((data)=>{
            let events = data.events;
            if (ctr.dataset.events !== 'single_event') // If the event is not a single event, we need to filter it to get the events we have specified in the data attribute.
            events = (0, $caa775a85f16e8d6$export$abcd98354d9fb0f7)(ctr.dataset.timeFilter, data.events);
            else if (ctr.dataset.events === 'single_event' && data.events.find((event)=>event.repeating)) // If the event is repeating, we need to filter it to get the next upcoming date.
            events = (0, $caa775a85f16e8d6$export$abcd98354d9fb0f7)('upcoming_events', data.events);
            if (events.length) (0, $84bd0f83cdc12d01$export$ff0eb5149c4c561a)(ctr, data.labels, events);
            else (0, $84bd0f83cdc12d01$export$8f410212441577b3)(ctr, data.labels.no_data);
            $933adbd7235e0034$var$observer.unobserve(ctr);
            (0, $84bd0f83cdc12d01$export$e7b6f2bce646ceb2)(ctr);
        }).catch((error)=>{
            console.error(error);
            return false;
        });
    });
});
const $933adbd7235e0034$var$containers = document.querySelectorAll((0, $4d206bedaaca27bd$export$16c08b91f883959a).selectors.events);
$933adbd7235e0034$var$containers.forEach((ctr)=>{
    $933adbd7235e0034$var$observer.observe(ctr);
});

})();
//# sourceMappingURL=event.min.js.map
